export default {
  data () {
    return {
      limitInMb: 5
    }
  },
  methods: {
    sortArrayByProperty (array, property, order) {
      array = array || []
      property = property || 'name'
      order = order || 'asc'
      if (array.length < 1) {
        return array
      }
      return this.$lodash().sortBy(array, [obj => obj[property].toLowerCase()], order)
    },
    getLocalStorageSizeUsed () {
      var sizeInKb = (unescape(encodeURIComponent(JSON.stringify(localStorage))).length) / 1024
      return Math.round(sizeInKb)
    },
    getLocalStorageSizeAvailable () {
      var sizeInKb = ((1024 * 1024 * this.limitInMb) - unescape(encodeURIComponent(JSON.stringify(localStorage))).length) / 1024
      return Math.round(sizeInKb)
    },
    nl2br (str, is_xhtml) {
      var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>'
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
    },
    getImageToken() {
      if (
          this.$store.getters.imageToken === null
          || (
              this.$store.getters.imageToken !== 'loading'
              && this.$moment(this.$store.getters.imageTokenExpiresAt) < this.$moment()
          )
          || (
              this.$store.getters.imageToken === 'loading'
              && (
                  this.$moment(this.$store.getters.imageTokenExpiresAt) < this.$moment()
                  || this.$store.getters.imageTokenExpiresAt === null
              )
          )
      ) {
        this.$store.commit('SET_IMAGE_TOKEN', 'loading')
        this.$store.commit('SET_IMAGE_TOKEN_EXPIRES_AT', this.$moment().add(15, 'seconds'))

        this.$request.get( '/authentication/image-token')
            .then((response) => {
              this.$store.commit('SET_IMAGE_TOKEN', response.data.token)
              this.$store.commit('SET_IMAGE_TOKEN_EXPIRES_AT', response.data.expires_at)
            })
            .catch(() => {
              this.$store.commit('SET_IMAGE_TOKEN', null)
            })
      }
    },
    resetStateIfNeeded (callbackAfterReset, callbackNoResetNeeded) {
      var dataStructureVersion = this.$store.getters.dataStructureVersion
      if (dataStructureVersion !== this.app.data_structure_version) {
        this.resetState(callbackAfterReset)
      } else {
        callbackNoResetNeeded()
      }
    },
    resetState (callback) {
      var deviceToken = this.$store.getters.deviceToken
      var session = this.$store.getters.session
      var useBeta = this.$store.getters.useBeta
      this.$store.commit('RESET_STATE')
      this.$store.commit('SET_DATA_STRUCTURE_VERSION', this.app.data_structure_version)
      this.$store.commit('SET_DEVICE_TOKEN', deviceToken)
      this.$store.commit('SET_SESSION', session)
      this.$store.commit('SET_USE_BETA', useBeta)
      if (session !== null) {
        this.$store.dispatch('loadApplicationSettings', callback)
      } else {
        callback()
      }
    },
    closeMainNavbarIfNeeded () {
      const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (screenWidth > 577) {
        this.$store.commit('SET_SHOW_MAIN_NAVBAR', true)
      } else {
        this.$store.commit('SET_SHOW_MAIN_NAVBAR', false)
        this.scrollToTop()
      }
    },
    scrollToTop() {
      const element = document.getElementById('app')
      const top = element.offsetTop
      window.scrollTo(0, top)
    },
    downloadPDF(filename, data) {
      const blob = new Blob([data], {type: 'application/pdf'})
      const url = URL.createObjectURL(blob)
      const aLink = document.createElement('a')
      aLink.href = url
      aLink.download = filename
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      URL.revokeObjectURL(url)
    },
    isGastouderapp() {
      const path = window.location.pathname;
      return path.startsWith('/gastouderapp') || process.env.VUE_APP_BASE === '/gastouderapp/';
    }
  }
}
